<template>
  <b-card>
    <div class="d-flex">
      <h4 class="mb-0">Banner Information</h4>
    </div>

    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >

      <b-form class="mt-1" @submit.prevent="onSubmit">
        <b-row>
          <b-col cols="12" v-if="bannerData.banner_image_url">
            <hr />
            <img
              style="width: 350px"
              :src="bannerData.banner_image_url"
            />
          </b-col>
          <b-col cols="12">
            <hr />
          </b-col>
          <b-col md="12">
            <b-form-group label="Banner Image" label-cols-md="3">
              <el-upload
                class="avatar-uploader"
                list-type="picture-card"
                ref="upload"
                :action="uploadUrl"
                :headers="headerObj"
                name="image_file"
                :file-list="fileList"
                multiple
                :limit="1"
                :data="bannerData"
                :on-change="onChange"
                :auto-upload="false"
                :class="{ hideUpload: !showUpload }"
              >
                <img
                  v-if="bannerData.banner_image_path && false"
                  :src="getImgPath(bannerData.banner_image_path)"
                  class="avatar"
                />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>

            </b-form-group>
          </b-col>
          <b-col cols="12" md="12">
              <b-form-group label="Main Title" label-for="banner_main_title" label-cols-md="3">
               <b-form-input
                    id="banner_main_title"
                    v-model="bannerData.banner_main_title"
                  />
              </b-form-group>
            </b-col>

            <b-col cols="12" md="12">
              <b-form-group label="Banner Items" label-cols-md="3">
                <div v-for="(item, index) in bannerItems" :key="index" class="mb-3 border p-3 rounded">
                  <div class="d-flex justify-content-between mb-2">
                    <h5 class="mb-0">Banner Item {{ index + 1 }}</h5>
                    <b-button variant="danger" size="sm" @click="removeBannerItem(index)">
                      <i class="feather icon-trash"></i> Remove
                    </b-button>
                  </div>

                  <b-form-group label="Title">
                    <b-form-input v-model="item.title" placeholder="Enter title"></b-form-input>
                  </b-form-group>

                  <b-form-group label="Content">
                    <TinyMCEEditor :content.sync="item.content" />
                  </b-form-group>
                </div>

                <b-button variant="primary" class="mt-2" @click="addBannerItem">
                  <i class="feather icon-plus"></i> Add Banner Item
                </b-button>
              </b-form-group>
            </b-col>
        </b-row>
        <!-- Form Actions -->

          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
            >
              Save
            </b-button>

          </div>
      </b-form>
    </b-overlay>
  </b-card>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BFormRadioGroup,
  BFormCheckboxGroup,
  BCard,
  BCardBody,
  BButton,
  BFormCheckbox,
  BFormDatepicker,
  BInputGroupAppend,
  BInputGroup,
  BFormInvalidFeedback,
  BOverlay,
  BFormTextarea,
} from "bootstrap-vue";
import TinyMCEEditor from "@/layouts/components/TinyMCEEditor.vue";
import Ripple from "vue-ripple-directive";
import store from "@/store";
import bannerStoreModule from "./bannerStoreModule";
import { ref, onUnmounted } from "@vue/composition-api";
import {getUserData} from '@/auth/utils'


export default {
  directives: {
    Ripple,
  },
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BForm,
    BFormGroup,
    BFormInput,
    BFormRadioGroup,
    BFormCheckboxGroup,
    BButton,
    BFormCheckbox,
    BFormDatepicker,
    BInputGroupAppend,
    BInputGroup,
    BFormInvalidFeedback,
    BOverlay,
    BFormTextarea,
    TinyMCEEditor,
  },
  methods: {
    toggleUpload() {
        this.showUpload = !this.showUpload
      },
    getImgPath(path) {
      return process.env.VUE_APP_IMAGE_URL + path;
    },
    addBannerItem() {
      this.bannerItems.push({
        title: '',
        content: ''
      });
    },
    removeBannerItem(index) {
      this.bannerItems.splice(index, 1);
    },
    onSubmit() {
      this.$swal({
        title: "Are you sure?",
        showCancelButton: true,
        confirmButtonText: "Save",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          let formData = new FormData()
          formData.append('store_id', getUserData().store_id)
          if(this.bannerData.banner_image_url == null || this.bannerData.banner_image_url && this.bannerData.file){
            formData.append('file', this.bannerData.file)
          }
          if(this.bannerData.banner_main_title){
            formData.append('banner_main_title', this.bannerData.banner_main_title)
          }else{
            formData.append('banner_main_title', "")
          }

          // 添加 banner_items 數據
          formData.append('banner_items', JSON.stringify(this.bannerItems))
          this.loading = true;
          store
            .dispatch("banner/addBanner", formData)
            .then((response) => {
              this.loading = false;
              this.$swal({
                text: response.data.message,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });

              this.refetchData()
              if (this.bannerData.id == 0) {
                // Return to banner list
                this.hide();
              }


            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                text: JSON.stringify(error.response.data.message),
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });


        }
      });
    },
  },
  setup() {
    const loading = ref(false);
    const fileList = ref([]);
    const bannerData = ref({});
    const bannerItems = ref([{
      title: '',
      content: ''
    }]);
    const BANNER_STORE_MODULE_NAME = "banner";
    const image_base_url = ref("");
    const showUpload = ref(true)

    if (!store.hasModule(BANNER_STORE_MODULE_NAME))
      store.registerModule(BANNER_STORE_MODULE_NAME, bannerStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(BANNER_STORE_MODULE_NAME))
        store.unregisterModule(BANNER_STORE_MODULE_NAME);
    });

    const refetchData = () => {
      store
        .dispatch(BANNER_STORE_MODULE_NAME + "/fetchStore")
        .then((response) => {
          bannerData.value = response.data.data;
          image_base_url.value = response.data.image_base_url;
          console.log(response.data.data);

          // 初始化 bannerItems
          if (bannerData.value.banner_items) {
            try {
              const parsedItems = JSON.parse(bannerData.value.banner_items);
              bannerItems.value = parsedItems.length > 0 ? parsedItems : [{
                title: '',
                content: ''
              }];
            } catch (e) {
              bannerItems.value = [{
                title: '',
                content: ''
              }];
            }
          } else {
            bannerItems.value = [{
              title: '',
              content: ''
            }];
          }
        });
    };

    refetchData();

    const onChange = (file) => {
      showUpload.value = !showUpload.value
      bannerData.value.file = file.raw;
    };

    const uploadUrl = ref(process.env.VUE_APP_SERVICE_URL + "/banner");
    const headerObj = {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
    };

    return {
      loading,
      fileList,
      onChange,
      refetchData,
      bannerData,
      bannerItems,

      // For Image
      uploadUrl,
      headerObj,
      showUpload,
    };
  },
};
</script>

<style lang="scss">


</style>